module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal col-xs-12 absolute-parlsey-errors",
    attrs: {
      "id": "form_questions_create"
    }
  }, [_c('div', {
    staticClass: "form-body col-xs-12"
  }, [_vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      staticClass: "mt-element-ribbon col-xs-12"
    }, [_c('div', {
      staticClass: "ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase"
    }, [_c('div', {
      staticClass: "ribbon-sub ribbon-clip"
    }), _vm._v(" Question n°" + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('a', {
      staticClass: "bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.addQuestion(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Ajouter")]), _vm._v(" "), _c('a', {
      staticClass: "text-danger bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.removeQuestion(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-close",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Supprimer\n          ")]), _vm._v(" "), (index < _vm.questions.length - 1) ? _c('a', {
      staticClass: "text-info bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.moveQuestion(index, index + 2)
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Descendre")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('a', {
      staticClass: "text-info bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.moveQuestion(index, index - 1)
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-up",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Monter")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.title),
        expression: "question.title"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "",
        "required": ""
      },
      domProps: {
        "value": (question.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.title = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-3 control-label"
    }, [_vm._v("Description\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.description),
        expression: "question.description"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (question.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.description = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    }), _vm._v(" "), _c('span', {
      staticClass: "help-block"
    }, [_vm._v("La description apparaîtra en dessous du titre pour expliquer votre question si besoin.")])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.type),
        expression: "question.type"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          question.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "text"
      }
    }, [_vm._v("Réponse ouverte")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "radio"
      }
    }, [_vm._v("Choix unique simple")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "checkbox"
      }
    }, [_vm._v("Choix multiples simple")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "checkbox_multiple"
      }
    }, [_vm._v("Choix multiples avec système d'imbrication à deux niveaux")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "radio_multiple"
      }
    }, [_vm._v("Choix unique avec système d'imbrication à deux niveaux")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "scale"
      }
    }, [_vm._v("Echelle de notation")])])])]), _vm._v(" "), (question.type == 'scale' || question.type == 'radio' || question.type == 'checkbox' || question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-5 control-label"
    }, [_vm._v("Couleur pour le choix 'ne se prononce pas'\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "box-color",
      style: ({
        'background-color': question.color_no_response
      }),
      on: {
        "click": function($event) {
          _vm.showColorPicker(index)
        }
      }
    }, [_c('input', {
      staticClass: "form-control input-color hide",
      attrs: {
        "type": "text",
        "id": 'colorPicker' + index,
        "data-index-question": index,
        "data-swatches": _vm.dataSwatches,
        "value": ""
      }
    })])])]) : _vm._e(), _vm._v(" "), (question.type == 'number' || question.type == 'scale') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.min),
        expression: "question.min"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0",
        "max": question.max ? question.max : '',
        "required": ""
      },
      domProps: {
        "value": (question.min)
      },
      on: {
        "change": function($event) {
          _vm.addColors(question)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.min = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]) : _vm._e(), _vm._v(" "), (question.type == 'number' || question.type == 'scale') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.max),
        expression: "question.max"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": question.min ? question.min : 1,
        "required": ""
      },
      domProps: {
        "value": (question.max)
      },
      on: {
        "change": function($event) {
          _vm.addColors(question)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.max = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]) : _vm._e(), _vm._v(" "), _vm._l((question.data), function(data, index_data) {
      return (question.type == 'select' || question.type == 'radio' || question.type == 'checkbox' || question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('div', [_c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-3 col-sm-2 col-xs-11 col-xs-offset-1 control-label"
      }, [_vm._v("Choix n°" + _vm._s(index_data + 1) + "\n                    "), _c('span', {
        staticClass: "required",
        attrs: {
          "aria-required": "true"
        }
      }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-3 col-md-5 col-sm-5 col-xs-6 col-xs-offset-1 col-sm-offset-0"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (data.name),
          expression: "data.name"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "required": ""
        },
        domProps: {
          "value": (data.name)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            data.name = $event.target.value
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2"
      }, [_c('div', {
        staticClass: "box-color",
        style: ({
          'background-color': data.color
        }),
        attrs: {
          "data-toggle": "tooltip",
          "title": "Couleur associé pour le graphique."
        },
        on: {
          "click": function($event) {
            _vm.showColorPicker(index, null, index_data)
          }
        }
      }, [_c('input', {
        staticClass: "form-control input-color hide",
        attrs: {
          "type": "text",
          "id": 'colorPicker' + index + '-data-' + index_data,
          "data-index-question": index,
          "data-index-data": index_data,
          "data-swatches": _vm.dataSwatches,
          "value": ""
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2 mt-10"
      }, [_c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (question.data.length > 1),
          expression: "question.data.length > 1"
        }],
        staticClass: "text-danger",
        staticStyle: {
          "white-space": "nowrap"
        },
        on: {
          "click": function($event) {
            question.data.splice(index_data, 1)
          }
        }
      }, [_c('span', {
        staticClass: "icon-close",
        attrs: {
          "aria-hidden": "true"
        }
      })])]), _vm._v(" "), (index_data == question.data.length - 1) ? _c('div', {
        staticClass: "col-xs-11 col-md-7 text-right mt-20"
      }, [_c('a', {
        staticStyle: {
          "white-space": "nowrap"
        },
        on: {
          "click": function($event) {
            question.data.push({
              name: ''
            })
          }
        }
      }, [_c('span', {
        staticClass: "icon-plus",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Ajouter")])]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _vm._l((question.data), function(choice, i) {
      return (question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input p-0 m-0"
      }, [_c('label', {
        staticClass: "col-md-3 control-label"
      }, [_vm._v("\n                  Question imbriquée choix: " + _vm._s(choice.name) + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [(!choice.question) ? _c('a', {
        staticClass: "btn",
        on: {
          "click": function($event) {
            choice.question = {
              title: '',
              type: '',
              data: [],
              min: null,
              max: null,
              color_no_response: '#00b0f0',
              colors: []
            };
            _vm.$forceUpdate()
          }
        }
      }, [_c('span', {
        staticClass: "icon-plus",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Ajouter")]) : _vm._e()])]), _vm._v(" "), (choice.question) ? _c('div', {
        staticClass: "col-xs-12 mt-10"
      }, [_c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_vm._m(4, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.title),
          expression: "choice.question.title"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "required": ""
        },
        domProps: {
          "value": (choice.question.title)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.title = $event.target.value
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-3 control-label"
      }, [_vm._v("\n                    Description:\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.description),
          expression: "choice.question.description"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (choice.question.description)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.description = $event.target.value
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_vm._m(5, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.type),
          expression: "choice.question.type"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "required": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            choice.question.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }, function($event) {
            _vm.addData(choice)
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "text"
        }
      }, [_vm._v("Réponse ouverte")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "radio"
        }
      }, [_vm._v("Choix unique simple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "checkbox"
        }
      }, [_vm._v("Choix multiples simple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "scale"
        }
      }, [_vm._v("Echelle de notation")])])])]), _vm._v(" "), (choice.question.type == 'scale' || choice.question.type == 'radio' || choice.question.type == 'checkbox' || choice.question.type == 'checkbox_multiple' || choice.question.type == 'radio_multiple') ? _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-5 control-label"
      }, [_vm._v("Couleur pour le choix 'ne se prononce pas'\n                      ")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3"
      }, [_c('div', {
        staticClass: "box-color",
        style: ({
          'background-color': choice.question.color_no_response
        }),
        on: {
          "click": function($event) {
            _vm.showColorPicker(index, null, null, null, i)
          }
        }
      }, [_c('input', {
        staticClass: "form-control input-color hide",
        attrs: {
          "type": "text",
          "id": 'colorPicker' + index + '-question-' + i,
          "data-index-question": index,
          "data-index-question-two": i,
          "data-swatches": _vm.dataSwatches,
          "value": ""
        }
      })])])]) : _vm._e(), _vm._v(" "), _vm._l((choice.question.data), function(choice_data, di) {
        return (choice.question.type == 'checkbox' || choice.question.type == 'radio') ? _c('div', {
          staticClass: "col-xs-12 form-group form-md-line-input"
        }, [_c('div', {
          staticClass: "form-group form-md-line-input p-0 m-0"
        }, [_c('label', {
          staticClass: "col-md-3 col-sm-2 col-xs-11 col-xs-offset-1 control-label"
        }, [_vm._v("Choix n°" + _vm._s(di + 1) + "\n                      "), _c('span', {
          staticClass: "required",
          attrs: {
            "aria-required": "true"
          }
        }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
          staticClass: "col-lg-3 col-md-5 col-sm-5 col-xs-6 col-xs-offset-1 col-sm-offset-0"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (choice_data.name),
            expression: "choice_data.name"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "required": ""
          },
          domProps: {
            "value": (choice_data.name)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              choice_data.name = $event.target.value
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "form-control-focus"
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2"
        }, [_c('div', {
          staticClass: "box-color",
          style: ({
            'background-color': choice_data.color
          }),
          attrs: {
            "data-toggle": "tooltip",
            "title": "Couleur associé pour le graphique."
          },
          on: {
            "click": function($event) {
              _vm.showColorPicker(index, null, i, di)
            }
          }
        }, [_c('input', {
          staticClass: "form-control input-color hide",
          attrs: {
            "type": "text",
            "id": 'colorPicker' + index + '-data-' + i + '-data2-' + di,
            "data-index-question": index,
            "data-index-data": i,
            "data-index-data-two": di,
            "data-swatches": _vm.dataSwatches,
            "value": ""
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2 mt-10"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (choice.question.data.length > 1),
            expression: "choice.question.data.length > 1"
          }],
          staticClass: "text-danger",
          staticStyle: {
            "white-space": "nowrap"
          },
          on: {
            "click": function($event) {
              choice.question.data.splice(di, 1)
            }
          }
        }, [_c('span', {
          staticClass: "icon-close",
          attrs: {
            "aria-hidden": "true"
          }
        })])]), _vm._v(" "), (di == choice.question.data.length - 1) ? _c('div', {
          staticClass: "col-xs-11 col-md-7 text-right mt-20"
        }, [_c('a', {
          staticStyle: {
            "white-space": "nowrap"
          },
          on: {
            "click": function($event) {
              choice.question.data.push({
                name: ''
              });
              _vm.forceUpdate()
            }
          }
        }, [_c('span', {
          staticClass: "icon-plus",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Ajouter")])]) : _vm._e()])]) : _vm._e()
      }), _vm._v(" "), (choice.question.type == 'scale') ? _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_vm._m(6, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.min),
          expression: "choice.question.min"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "min": "0",
          "max": choice.question.max ? choice.question.max : '',
          "required": ""
        },
        domProps: {
          "value": (choice.question.min)
        },
        on: {
          "change": function($event) {
            _vm.addColors(choice.question)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.min = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_vm._m(7, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.max),
          expression: "choice.question.max"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "min": choice.question.min ? choice.question.min : 1,
          "required": ""
        },
        domProps: {
          "value": (choice.question.max)
        },
        on: {
          "change": function($event) {
            _vm.addColors(choice.question)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.max = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), (choice.question.type == 'scale') ? _c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-3 control-label"
      }, [_vm._v("Couleurs associées\n                        ")]), _vm._v(" "), (choice.question.max && choice.question.min) ? _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [(parseInt(choice.question.max) - parseInt(choice.question.min) + 1 > 0) ? _c('div', _vm._l((choice.question.colors), function(color, index_data_color) {
        return _c('div', {
          staticClass: "box-color",
          style: ({
            'background-color': color
          }),
          on: {
            "click": function($event) {
              _vm.showColorPicker(index, index_data_color, i)
            }
          }
        }, [_vm._v("\n                          " + _vm._s(index_data_color + parseInt(choice.question.min)) + "\n                          "), _c('input', {
          staticClass: "form-control input-color hide",
          attrs: {
            "type": "text",
            "id": 'colorPicker' + index + '-data-' + i + '-' + index_data_color,
            "data-index-question": index,
            "data-index-data": i,
            "data-index-color": index_data_color,
            "data-swatches": _vm.dataSwatches,
            "value": ""
          }
        })])
      })) : _c('div', {
        staticClass: "text-danger",
        staticStyle: {
          "margin-top": "5px"
        }
      }, [_vm._v("\n                        Valeur invalide. La valeur maximum doit être supérieure à la valeur minimum.\n                      ")])]) : _c('div', {
        staticClass: "col-lg-6 col-md-9",
        staticStyle: {
          "margin-top": "5px",
          "color": "gray"
        }
      }, [_vm._v("\n                      Vous devez saisir les valeurs minimum et maximum.\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12"
      }, [_c('div', {
        staticClass: "col-md-3"
      }), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9 p-0"
      }, [_c('a', {
        staticClass: "p-0 btn text-danger",
        on: {
          "click": function($event) {
            choice.question = null;
            _vm.forceUpdate()
          }
        }
      }, [_c('span', {
        staticClass: "icon-close",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Retirer")])])])], 2) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), (question.type == 'scale') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-3 control-label"
    }, [_vm._v("Couleurs associées\n                  ")]), _vm._v(" "), (question.max && question.min) ? _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [(parseInt(question.max) - parseInt(question.min) + 1 > 0) ? _c('div', _vm._l((question.colors), function(color, index_color) {
      return _c('div', {
        staticClass: "box-color",
        style: ({
          'background-color': color
        }),
        on: {
          "click": function($event) {
            _vm.showColorPicker(index, index_color)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(index_color + parseInt(question.min)) + "\n                    "), _c('input', {
        staticClass: "form-control input-color hide",
        attrs: {
          "type": "text",
          "id": 'colorPicker' + index + '-' + index_color,
          "data-index-question": index,
          "data-index-color": index_color,
          "data-swatches": _vm.dataSwatches,
          "value": ""
        }
      })])
    })) : _c('div', {
      staticClass: "text-danger",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_vm._v("\n                  Valeur invalide. La valeur maximum doit être supérieure à la valeur minimum.\n                ")])]) : _c('div', {
      staticClass: "col-lg-6 col-md-9",
      staticStyle: {
        "margin-top": "5px",
        "color": "gray"
      }
    }, [_vm._v("\n                Vous devez saisir les valeurs minimum et maximum.\n              ")])]) : _vm._e(), _vm._v(" "), (index != _vm.questions.length - 1) ? _c('hr', {
      staticStyle: {
        "width": "80%",
        "margin": "auto",
        "border-style": "dashed",
        "position": "relative",
        "top": "60px",
        "border-color": "gray"
      }
    }) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [(_vm.questions.length == 0) ? _c('div', {
    staticClass: "note note-danger"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Avertissement")]), _vm._v(" "), _c('p', [_vm._v(" Votre questionnaire doit comporter au moins une question ! "), _c('br'), _vm._v("\n                Cliquez sur le bouton en bas à droite "), _c('a', {
    on: {
      "click": function($event) {
        _vm.addQuestion()
      }
    }
  }, [_vm._v("Ajouter une question")]), _vm._v(".\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.addQuestion()
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ajouter une question")])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Titre\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Type\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur minimum\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur maximum\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("\n                    Titre:\n                    "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("\n                    Type:\n                    "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur minimum\n                        "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur maximum\n                        "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e474940"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quizzes/create_questions.vue
// module id = 105
// module chunks = 0